module.exports = __webpack_public_path__ + "img/main.dff920f7.png";